<h2 mat-dialog-title class="hub-title">
  <span>{{ 'supportTickets.dialogTitleHub' | translate }}</span>
  <button
    mat-icon-button
    type="button"
    (click)="close()"
    [attr.aria-label]="'supportTickets.closeAria' | translate"
  >
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="hub-dialog-content">
  <nx-c4g-support-ticket-hub [source]="data.source" />
</mat-dialog-content>
